import React from 'react';
import SuppliersPage from './SuppliersPage';
import SuppliersMobilePage from './SuppliersPageMobile';
import ResponsiveWrapper from '../../components/common/ResponsiveWrapper';


const SuppliersPageWrapper: React.FC = React.memo(() => {
  return (
    <>
      <ResponsiveWrapper
        mobileComponent={SuppliersMobilePage}
        desktopComponent={SuppliersPage}
      />
    </>
  );
});

SuppliersPageWrapper.displayName = 'SuppliersPageWrapper';

export default SuppliersPageWrapper; 